const getLastSelectedRow = (formData, rows) => {
    if (rows.length === 0) {
        return formData.length > 0 ? formData.length - 1 : 0;
    }
    return rows[rows.length - 1].rowIndex;
};
export const addRow = (formData, schema, uiSchema) => {
    const newFormData = formData.slice();
    const newRow = buildNewRow(uiSchema, schema);
    newFormData.splice(0, 0, newRow);
    return newFormData;
};
export const deleteRow = (formData, rows) => {
    const selectedIndexes = rows.map((row) => parseInt(row.id));
    const newFormData = formData.filter((_element, index) => !selectedIndexes.includes(index));
    return { newFormData, selectedIndexes };
};
export const duplicateRow = (formData, rows) => {
    let newFormData = formData.slice();
    rows.forEach((row) => {
        let index = row.id;
        delete row.id;
        newFormData.splice(parseInt(index), 0, row);
    });
    return newFormData;
};
export const pasteRow = (formData, rows, schema, selectedNodes) => {
    rows.forEach((row) => {
        delete row.id;
    });
    const fit = rows.every((row) => willDataFit(row, schema.items));
    let newFormData = formData.slice();
    if (fit) {
        const insertPosition = getLastSelectedRow(formData, selectedNodes);
        newFormData.splice(insertPosition + 1, 0, ...rows);
    }
    else {
        newFormData = null;
    }
    return newFormData;
};
export const moveRowUp = (formData, rowIndex) => {
    const newFormData = formData.slice();
    const row = newFormData[rowIndex];
    delete row.id;
    let tempRow = newFormData[rowIndex - 1];
    newFormData[rowIndex - 1] = row;
    newFormData[rowIndex] = tempRow;
    return newFormData;
};
export const moveRowDown = (formData, rowIndex) => {
    const newFormData = formData.slice();
    const row = newFormData[rowIndex];
    delete row.id;
    let tempRow = newFormData[rowIndex + 1];
    newFormData[rowIndex + 1] = row;
    newFormData[rowIndex] = tempRow;
    return newFormData;
};
export function buildNewRow(uiSchema, schema) {
    let newRow = {};
    let properties = typeof schema.items !== "undefined"
        ? schema.items.properties
        : schema.properties;
    for (let fieldName in properties) {
        if (typeof uiSchema[fieldName]["ui:field"] !== "undefined") {
            let cell = {};
            switch (uiSchema[fieldName]["ui:field"]) {
                case "browsefield":
                case "browsefield2":
                case "folderfield":
                case "plotfield":
                case "stringfield":
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : "";
                    break;
                case "menufield":
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : properties[fieldName].enum[0];
                    break;
                case "epochselfield":
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : {};
                    break;
                case "intervalfield":
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : {};
                    break;
                case "arrayfield":
                    const itemsNumber = properties[fieldName];
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : new Array(itemsNumber.maxItems).fill(0);
                    break;
                case "matrixfield":
                    const items = properties[fieldName];
                    const rows = items.maxItems;
                    const columns = items.items.maxItems;
                    const type = items.items.items.type;
                    let defaultValue;
                    if (type == "string") {
                        defaultValue = " ";
                    }
                    else if (type == "integer" || type == "number") {
                        defaultValue = 0;
                    }
                    if (type == "boolean") {
                        defaultValue = "false";
                    }
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : new Array(rows).fill(new Array(columns).fill(defaultValue));
                    break;
                case "numericfield":
                    const tempDef = typeof properties[fieldName].default !== "undefined"
                        ? typeof properties[fieldName].default === "string"
                            ? parseFloat(properties[fieldName].default)
                            : properties[fieldName].default
                        : undefined;
                    const tempMin = typeof properties[fieldName].minimum !== "undefined"
                        ? properties[fieldName].minimum
                        : undefined;
                    cell =
                        typeof tempDef !== "undefined"
                            ? typeof tempMin !== "undefined" && tempDef < tempMin
                                ? tempMin
                                : tempDef
                            : 0;
                    break;
                case "yesnofield":
                    cell =
                        typeof properties[fieldName].default !== "undefined"
                            ? properties[fieldName].default
                            : false;
                    break;
                case "listfield":
                    cell = [];
                    break;
                case "tabfield":
                case "separator":
                    cell = buildNewRow(uiSchema[fieldName], properties[fieldName]);
                    break;
                default:
                    break;
            }
            newRow[fieldName] = cell;
        }
    }
    return newRow;
}
export function willDataFit(formData, schema) {
    let isValid;
    for (const key in formData) {
        if (key in schema.properties) {
            const type = schema.properties[key].type;
            if (type === "object") {
                isValid = willDataFit(formData[key], schema.properties[key]);
                if (!isValid) {
                    return false;
                }
            }
            if (type === "array" && schema.properties[key].items === "object") {
                isValid = willDataFit(formData[key], schema.properties[key].items);
                if (!isValid) {
                    return false;
                }
            }
        }
        else {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=formList.js.map